<template>
  <v-select
    class="table-header-sort-select"
    :items="menuItems"
    :value="sortVal"
    placeholder="Sort"
    dense
    hide-details
    @change="updateSortVal"
    outlined
    single-line
    clearable
  />
</template>

<script>
import { Model } from '@vuex-orm/core'
import AllModels from '@/models'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
export default {
  name: 'ManageBaseTableSortMenu',
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
  },
  components: {},
  computed: {
    ...mapGetters('shop', ['getEnableItemDates']),

    menuItems() {
      let items = []
      let headers = this.Model.field_headers ? this.Model.field_headers() : []
      if (
        this.Model.namePlural === AllModels.ItemModel.namePlural &&
        !this.getEnableItemDates
      ) {
        // If we're building the ItemModel headers and ITEM_DATES flag is disabled,
        // remove the date column if it exists
        headers = headers.filter((h) => _get(h, 'value') !== 'date')
      }

      headers.forEach((h) => {
        if (_get(h, 'sortable', false)) {
          let value = _get(h, 'sortKey', h.value)
          items.push({ text: `${h.text} : ↑`, value: `${value}` })
          items.push({ text: `${h.text} : ↓`, value: `-${value}` })
        }
      })
      return items
    },
  },
  data() {
    return {
      sortVal: null,
    }
  },
  created() {
    if (this.$route.query.sort) {
      this.sortVal = this.menuItems.find(
        (i) => i.value === this.$route.query.sort
      )
    }
  },
  methods: {
    updateSortVal(value) {
      let routeQuery = {
        ...this.$route.query,
        ...(value && { sort: value }),
      }
      if (!value) {
        // remove prepended '-' if sortDesc === false
        delete routeQuery.sort
        delete routeQuery.page
      }
      this.$router.push({ ...this.$route, query: routeQuery })
    },
  },
}
</script>

<style lang="scss">
.table-header-sort-select {
  .v-select__selection {
    font-size: 0.85rem;
    margin: 0;
  }
}
</style>
